import { createContext, useContext } from "react";

import type { CsspSuppliersStore } from "./CsspSuppliersStore";

const CsspSuppliersContext = createContext<CsspSuppliersStore | null>(null);

export const useCsspSuppliersStore = () => {
  const store = useContext(CsspSuppliersContext);
  if (!store) throw new Error("CsspSuppliersProvider is required");
  return store;
};

export default CsspSuppliersContext;
